<div class="login_form">

    <div class="logo">
        <img src="../../../../../assets/images/logo/flowtrics_logo.png">
    </div>

    <div class="title" *ngIf= "!showLoginForm">LOGIN TO YOUR <span>GUEST</span> PORTAL ACCOUNT</div>   
    
    <form name="loginForm" [formGroup]="loginForm"  novalidate *ngIf= "!showLoginForm">

        <mat-form-field appearance="fill" *ngIf="!displayValidatorField">
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" type="text" autocomplete="off"  maxlength="50" placeholder="Enter email address" >
            <mat-icon matSuffix class="secondary-text">mail</mat-icon>
            <mat-error *ngIf="loginForm.get('email').hasError('required')">
                Email is required
            </mat-error>
            <mat-error
                *ngIf="!loginForm.get('email').hasError('required') &&
                        loginForm.get('email').hasError('email')">
                Please enter a valid email address
            </mat-error>
        </mat-form-field>

        <re-captcha *ngIf="!displayValidatorField && isShowrecaptchaReactive"
        (resolved)="addTokenLog(true, $event)"
      ></re-captcha>
        
        <button type="button" mat-raised-button color="primary" class="submit-button" aria-label="LOG IN" *ngIf="!displayValidatorField"
              (click)="login(loginForm)"  [disabled]="diableLogin(loginForm)">
            LOGIN
        </button>      

        <hr class="line" >
       

        <button type="button" mat-raised-button color="primary" class="submit-button adminLogin"  routerLink="/auth/login" >
           GO TO LOGIN ADMIN
        </button>   

    </form>


    <div class="authenticate" *ngIf="showLoginForm">
        <div class="authinfo" fxLayout="column">           
            <div class="authopt mb-15">               
            
                <mat-form-field appearance="fill">
                    <mat-label>Enter OTP</mat-label>
                    <input matInput type="text" autocomplete="off"  maxlength="4" 
                    [(ngModel)]="otp" placeholder="Enter Otp code" 
                    (keypress)="numberOnly($event)">                   
                </mat-form-field>
            </div>

            <button mat-raised-button color="primary" class="submit-button" (click)="MatchOTP()" 
             aria-label="CONTINUE">CONTINUE</button>

            <span class="back" (click)="showLogin()"> <mat-icon>keyboard_arrow_left</mat-icon> Back to login</span>

        </div>
    </div>

</div>

<div class="progress-loader" *ngIf="spinner">
    <div class="lds-ripple" ><div></div><div></div></div>
  </div>
